import {
  IconAnalytics,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconCar,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/medicalPatient/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/medicalPatient/img/1.avif';
import image2 from '@src/assets/images/solution/medicalPatient/img/2.avif';
import image3 from '@src/assets/images/solution/medicalPatient/img/3.avif';
import image4 from '@src/assets/images/solution/medicalPatient/img/4.avif';
import image5 from '@src/assets/images/solution/medicalPatient/img/5.avif';
import { medicalPatient1, medicalPatient2, medicalPatient3, recommendationServer } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '의료 솔루션',
  banner: {
    title: '환자와 의료기기의 위치를 실시간으로 파악해 병원 운영을 안정화하세요',
    desc: '환자의 이동을 모니터링하고 외과 수술장비의 위치를 실시간으로 확인해 병원의 대응력을 높입니다',
  },

  recommend: {
    title: '환자와 수술장비에 태그를 부착해 위치를 실시간 추적하고 응급 대응을 지원합니다',
    desc: '환자에게 착용된 밴드와 장비에 부착된 태그가 병동 수신기와 연동되어 위치를 수집하고, 낙상과 이탈 등 이상 상황을 자동 감지합니다',
    labels: {
      desktop: [
        {
          img: medicalPatient1,
          data: recommendation.twintarckerBLE,
        },
        {
          img: medicalPatient2,
          data: recommendation.patientTag,
        },
        {
          img: medicalPatient3,
          data: recommendation.safetyBell,
        },
        {
          img: recommendationServer,
          data: recommendation.server,
        },
      ],
      mobile: [
        {
          data: recommendation.twintarckerBLE,
        },
        {
          data: recommendation.patientTag,
        },
        {
          data: recommendation.safetyBell,
        },
        {
          data: recommendation.stickerTag,
        },
        {
          data: recommendation.plutoconPro,
        },
        {
          data: recommendation.server,
        },
      ],
    },
  },

  video: {
    title: '환자와 의료장비의 위치 데이터를 기반으로 병원 운영 효율성을 높이세요.',
    desc: '환자의 위치 및 상태를 실시간으로 모니터링하고 의료장비와 병원 자산을 효율적으로 관리하여 운영 안정성을 높이고 사고를 예방합니다.',
    play: video,
  },

  func: [
    {
      theme: '환자와 의료장비를 실시간으로 모니터링하여 안전사고를 예방하세요.',
      title: '위험 환자 위치 실시간 추적',
      desc: '병원 내 위험 환자의 위치를 실시간으로 파악하여 긴급 상황 발생 시 즉시 대응할 수 있습니다. 환자의 정확한 위치 정보를 제공함으로써 의료진의 신속한 대응과 환자의 안전을 강화합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: '환자 전용 위치추적 밴드 제공',
      desc: '반 환자용 밴드와 동일한 형태로 제작된 전용 위치추적 밴드를 통해 환자의 움직임을 불편 없이 실시간으로 모니터링하며, 환자의 생활 편의성을 높이고 병원 관리의 효율성을 지원합니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image1,
    },
    {
      title: '낙상 사고 실시간 감지',
      desc: '환자의 낙상 사고를 즉시 감지하고 관리자에게 실시간으로 알림을 보내 신속한 응급 처치가 가능합니다. 이를 통해 환자의 안전을 높이고 의료진의 빠른 대응 능력을 향상시킵니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      video: subVideo3,
    },
    {
      title: '환자 허용구역 이탈 시 경고 알림',
      desc: '환자가 미리 지정된 허용구역을 벗어나면 즉각적으로 경고 알림이 관리자에게 전송되어, 환자의 무단 이탈을 방지하고 빠르게 대응할 수 있는 환경을 제공합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image2,
    },
    {
      theme: '병원 자산을 효율적으로 추적하여 관리 운영을 최적화하세요.',
      title: '자산 위치추적 전용 태그 제작',
      desc: '병원 내 다양한 의료 장비와 자산 관리를 위한 맞춤형 위치추적 전용 태그를 제공하여 자산의 분실과 낭비를 방지하고 자산 운용 효율성을 높입니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '이동식 외과 수술장비 모니터링',
      desc: '병원 내 이동식 외과 수술장비의 위치와 사용 상태를 실시간으로 정확하게 모니터링하여 수술 준비 시간을 단축하고 장비 활용도를 극대화할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '간호사실 전용 자산추적 태블릿 제공',
      desc: '간호사실에서 사용할 수 있는 자산추적 전용 태블릿을 제공하여 의료진이 병원 내 모든 자산과 장비 위치를 간편하게 실시간으로 확인할 수 있어 업무의 효율성과 편의성을 높입니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '환자 및 자산의 이동 경로 데이터 분석',
      desc: '추적 대상의 병원 내 이동 경로 데이터를 분석하여 행동 패턴과 병원 내 주요 이용 공간을 파악할 수 있습니다. 이를 통해 병원의 공간 운영 효율을 높이고 환자 관리 시스템을 최적화할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
  ],

  subfunc: {
    title: '기능 요약',
    desc: '의료 시설에서 가장 중요한 것은 환자의 건강입니다. 언제 어디서나 환자의 상태는 모니터링되어야 하며, 상황 발생 시 재빠른 초기 대응은 필수적입니다. 오브로는 아래와 같은 기능들을 제공하여, 언제나 안전한 의료 시설을 유지하도록 합니다.',

    data: [
      {
        icon: IconSearch, // 밴드 제공 → 장비/탐색/개별 식별 의미
        title: '환자 전용 밴드 제공',
        desc: '전용 위치밴드를 제공해 환자의 착용 불편 없이 생활 동선을 자연스럽게 추적합니다.',
      },
      {
        icon: IconRoute, // 실시간 위치 → 이동 경로 및 실시간 추적
        title: '환자 위치 실시간 추적',
        desc: '환자의 위치를 실시간으로 파악하여 응급 상황에 즉시 대응합니다.',
      },
      {
        icon: IconWarning, // 낙상 감지 → 위험 상황 실시간 알림
        title: '낙상 사고 자동 감지',
        desc: '침대 이탈이나 위험 자세 감지 시 의료진에게 실시간 알림을 전송해 즉시 대응할 수 있습니다.',
      },
      {
        icon: IconWarning, // 허용구역 이탈 → 경고/경계 알림
        title: '허용구역 이탈 알림',
        desc: '환자가 병실 또는 지정 구역을 벗어나면 실시간으로 관리자에게 경고 알림이 발송됩니다.',
      },
      {
        icon: IconSearch, // 자산 태그 → 탐색/식별 목적
        title: '자산 전용 태그 제공',
        desc: '이동형 수술장비와 진단기기에 부착된 태그로 자산 위치를 자동 추적하고 분실을 방지합니다.',
      },
      {
        icon: IconRoute, // 수술장비 위치 → 실시간 이동 추적
        title: '수술장비 실시간 위치 확인',
        desc: '주요 수술장비의 실시간 위치를 확인해 수술 준비 시간을 단축하고 장비 확보를 보장합니다.',
      },
      {
        icon: IconLayers, // 간호사실 단말 → 시각화된 위치정보 제공
        title: '간호사실 전용 단말 제공',
        desc: '간호사실에 비치된 태블릿으로 자산과 환자의 위치를 즉시 확인해 응급 대응 속도를 높입니다.',
      },
      {
        icon: IconAnalytics, // 이동 데이터 분석 → 병목, 회전률 시각화
        title: '이동 경로 데이터 분석',
        desc: '환자 및 자산의 이동 데이터를 분석해 병목 구간과 자산 회전률을 시각화하고 공간 운영을 최적화합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'peoplePackage',
    },
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalWaste',
    },
    {
      data: 'logisticsSafety',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
